/** biome-ignore-all lint/a11y/noStaticElementInteractions: pre-biome code */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: pre-biome code */
"use client"

import StartIcon from "@/components/icons/StartIcon"
import StopIcon from "@/components/icons/StopIcon"
import { CodeBlock } from "@/components/layout/code/CodeBlock"
import React, { Children, useEffect, useState } from "react"
import "./WandelscriptExecution.css"

interface QueueProps {
  data: string[]
}

const Queue = ({ data }: QueueProps) => {
  return (
    <div className="queueContainer">
      <span className="queueTitle">Motion queue</span>
      <div className="childContainer">
        {data?.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: old code
          <div key={index} className="queueItem">
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

interface LineProps {
  children: React.ReactNode
  action: string
  executionTime: number
}
const Line = ({ children }: LineProps) => {
  return <div>{children}</div>
}

interface AnimatedCodeExecutionProps {
  children: React.ReactNode
  active: boolean
}
const AnimatedCodeExecution = ({ children }: AnimatedCodeExecutionProps) => {
  const [activeLineIndex, setActiveLineIndex] = useState(0)
  const lines = Children.toArray(children)
  const [queue, setQueue] = useState<string[]>([])
  const [executing, setExecuting] = useState(false)

  const addToQueue = (line: string) => {
    setQueue((prevQueue) => [...prevQueue, line])
  }

  const clearQueue = () => {
    setQueue([])
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const executeAction = (action: string, currentLine: string) => {
    switch (action) {
      case "addToQueue":
        addToQueue(currentLine)
        break
      case "clearQueue":
        clearQueue()
        break
      default:
        console.log("No valid action specified")
    }
  }

  function increment() {
    const currentLine = lines[activeLineIndex]

    if (!React.isValidElement<LineProps>(currentLine)) {
      console.error("not a valid element")
      return
    }

    const executionTime = currentLine.props.executionTime || 1000
    const action = currentLine.props.action

    if (action) {
      executeAction(action, currentLine.props.children as string)
    }

    const nextLineIndex =
      activeLineIndex < lines.length - 1 ? activeLineIndex + 1 : 0
    setTimeout(() => {
      setActiveLineIndex(nextLineIndex)
    }, executionTime)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-biome code
  useEffect(() => {
    if (!executing) {
      return
    }

    const timer = setTimeout(increment, 1000)
    return () => clearInterval(timer)
  }, [activeLineIndex, executing])

  return (
    <div>
      <CodeBlock>
        {executing ? (
          <div className="stopIcon" onClick={() => setExecuting(false)}>
            <StopIcon />
          </div>
        ) : (
          <div className="startIcon" onClick={() => setExecuting(true)}>
            <StartIcon />
          </div>
        )}

        {lines.map((line, index) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: pre-biome code
            key={index}
            className={index === activeLineIndex ? "activeLine" : ""}
          >
            {line}
          </div>
        ))}
      </CodeBlock>
      <Queue data={queue} />
    </div>
  )
}

export { AnimatedCodeExecution, Line }
